import * as React from "react";
import type { SVGProps } from "react";
const SvgListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="list_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M85.333 213.333a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v128a128 128 0 0 1-128 128h-128a128 128 0 0 1-128-128v-128zm128-42.666a42.667 42.667 0 0 0-42.666 42.666v128A42.667 42.667 0 0 0 213.333 384h128A42.667 42.667 0 0 0 384 341.333v-128a42.667 42.667 0 0 0-42.667-42.666h-128zm-128 512a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v128a128 128 0 0 1-128 128h-128a128 128 0 0 1-128-128v-128zm128-42.667a42.667 42.667 0 0 0-42.666 42.667v128a42.667 42.667 0 0 0 42.666 42.666h128A42.667 42.667 0 0 0 384 810.667v-128A42.667 42.667 0 0 0 341.333 640h-128zm341.334-469.333A42.667 42.667 0 0 1 597.333 128H896a42.667 42.667 0 1 1 0 85.333H597.333a42.667 42.667 0 0 1-42.666-42.666zm0 469.333a42.667 42.667 0 0 1 42.666-42.667H896a42.667 42.667 0 1 1 0 85.334H597.333A42.667 42.667 0 0 1 554.667 640zm42.666-298.667a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H597.333zm-42.666 512a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 896H597.333a42.667 42.667 0 0 1-42.666-42.667z"
    />
  </svg>
);
export default SvgListIcon;
